import { render, staticRenderFns } from "./Atouts.vue?vue&type=template&id=1dd0274a&"
import script from "./Atouts.vue?vue&type=script&lang=js&"
export * from "./Atouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports